module.exports = __webpack_public_path__ + "static/spokoj_main_4-500876dbc7b04a923d1ada674d3205d3.png";